import { render, staticRenderFns } from "./LotteryHeroWheel.vue?vue&type=template&id=6504fb1c&scoped=true&"
import script from "./LotteryHeroWheel.vue?vue&type=script&lang=js&"
export * from "./LotteryHeroWheel.vue?vue&type=script&lang=js&"
import style0 from "./LotteryHeroWheel.vue?vue&type=style&index=0&id=6504fb1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6504fb1c",
  null
  
)

export default component.exports